var _defs, _rect, _path, _path2, _path3, _path4, _polyline, _polyline2, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapSkatepark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rep\\xE8re",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\r\n      stroke: #000;\r\n      }\r\n\r\n      .cls-1, .cls-3, .cls-4, .cls-5 {\r\n      stroke-linecap: round;\r\n      stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-1, .cls-5 {\r\n      stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n      stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n      stroke-width: 2.5px;\r\n      }\r\n\r\n      .cls-3, .cls-6, .cls-4, .cls-5 {\r\n      fill: none;\r\n      }\r\n\r\n      .cls-4 {\r\n      stroke-width: 3.5px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0.71,
    y: 1.53,
    width: 61,
    height: 61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.43,8.14c1.81-.38,2.96-2.15,2.57-3.96-.39-1.8-2.16-2.96-3.96-2.57-1.8.38-2.95,2.15-2.57,3.95.39,1.81,2.16,2.96,3.96,2.57h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40.06,19c-.71-.23-1.47.16-1.7.86-.23.71.16,1.47.87,1.7.71.23,1.47-.16,1.7-.87.23-.71-.16-1.47-.87-1.7h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36.03,31.43c-.71-.23-1.47.16-1.7.87-.23.71.16,1.47.87,1.7.71.23,1.47-.16,1.7-.87.23-.71-.16-1.47-.87-1.7h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.57,21.4c-.96,21.22-18.38,38.14-39.8,38.3v1.82h53.84V21.4h-14.04Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "5.22 20.43 8.79 13.96 15.5 9.79 21.72 8.36 24.8 3.77"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "33.39 19.51 27.17 16.11 21.11 19.14 23.13 25.63 28.61 31.79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.89,11.41s1.37,3.57,3.96,5.87,4.26,3.14,4.26,3.14l.33-1.45,3.62-1.81s-7.11-2.82-6.83-8l-2.73.63-3.14,1.95"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m37.57,14.57s.26,1.57-.6,4.99-3.95,12.77-3.95,12.77c0,0-1.51,2.87-1.98,3.12l-.47.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSkatepark);
export default __webpack_public_path__ + "static/media/map_skatepark.46c26b8b5dbd2355e035692643458221.svg";
export { ForwardRef as ReactComponent };